export default "__VITE_PUBLIC_ASSET__1859d9aa__"